import { Injectable } from '@angular/core';
import { BullhornDataSourceApiService } from 'datasource-service-lib';
import { INamedEntity } from 'interfaces-lib';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export type BullhornUserType = { type: 'UserType' } & INamedEntity;
export type BullhornDepartment = { type: 'Department' } & INamedEntity;
export type BullhornPrivateLabelId = { type: 'PrivateLabelId' } & INamedEntity;

@Injectable({ providedIn: 'root' })
export class BullhornUserRestrictionsService {
  private userTypes$: Observable<BullhornUserType[]> | null = null;
  private departments$: Observable<BullhornDepartment[]> | null = null;
  private privateLabels$: Observable<BullhornPrivateLabelId[]> | null = null;

  constructor(private dataSourceApiService: BullhornDataSourceApiService) {}

  getUserTypes(): Observable<BullhornUserType[]> {
    if (!this.userTypes$) {
      this.userTypes$ = this.dataSourceApiService
        .query2('UserType', { query: 'id>0 AND enabled=true AND isHidden=false', fields: 'id,name' })
        .pipe(
          map(response => response.map(record => ({ id: record.id, name: record.name, type: 'UserType' as const }))),
          catchError(err => {
            console.error('BullhornUserRestrictionsService: getUserTypes failed', err);
            return of([]);
          }),
          shareReplay(1)
        );
    }
    return this.userTypes$;
  }

  getDepartments(): Observable<BullhornDepartment[]> {
    if (!this.departments$) {
      this.departments$ = this.dataSourceApiService
        .query2('Department', { query: 'id>0 AND enabled=true', fields: 'id,name' })
        .pipe(
          map(response => response.map(record => ({ id: record.id, name: record.name, type: 'Department' as const }))),
          catchError(err => {
            console.error('BullhornUserRestrictionsService: getDepartments failed', err);
            return of([]);
          }),
          shareReplay(1)
        );
    }
    return this.departments$;
  }

  getPrivateLabels(): Observable<BullhornPrivateLabelId[]> {
    if (!this.privateLabels$) {
      this.privateLabels$ = this.dataSourceApiService
        .settings('allPrivateLabelIds')
        .pipe(
          map(response => response['allPrivateLabelIds'].map((record: any) => ({
            id: record.id,
            name: record.name,
            type: 'PrivateLabelId' as const
          }))),
          catchError(err => {
            console.error('BullhornUserRestrictionsService: getPrivateLabels failed', err);
            return of([]);
          }),
          shareReplay(1)
        );
    }
    return this.privateLabels$;
  }
}
